import { FC } from 'react';

import { usePaymentMethod } from '@mopla/business-logic';
import { EMlpIconTypes, EMplVariantTypes, MplIconMessage } from '@mopla/ui';

import { PaymentMethodLabel } from './PaymentMethodLabel';
import { isPurchaseBlockedBySepaRestriction } from './utils';

interface IPaymentMethodCollapsedSummaryProps {
	isSepaRestricted: boolean;
}

/**
 * Collapsed subtitle of the Zahlung section. For tickets that cannot be paid
 * via SEPA or Pay by Bank, a SEPA / Pay by Bank default is highlighted in an
 * orange box (MC-12048).
 *
 * Deliberately shares `isPurchaseBlockedBySepaRestriction` with the buy CTA so
 * the two stay in lockstep; unlike `PaymentMethodRestrictionNotice`, which does
 * NOT share it because that notice also renders when no default is saved.
 */
export const PaymentMethodCollapsedSummary: FC<
	IPaymentMethodCollapsedSummaryProps
> = ({ isSepaRestricted }) => {
	const { defaultPaymentMethod } = usePaymentMethod();

	if (
		isPurchaseBlockedBySepaRestriction(
			isSepaRestricted,
			defaultPaymentMethod?.type
		)
	) {
		return (
			<MplIconMessage
				type={EMlpIconTypes.Warning}
				variant={EMplVariantTypes.Warning}
				textVariant="l1"
				message={<PaymentMethodLabel color="inherit" />}
				dataTestid="PaymentMethodCollapsedSummary-MplIconMessage-text"
			/>
		);
	}

	return <PaymentMethodLabel />;
};
